import mobWebp from '../../images/contact/mobile/contact.webp';
import mobWebp2x from '../../images/contact/mobile/contact@2x.webp';
import mobJpeg from '../../images/contact/mobile/contact.jpg';
import mobJpeg2x from '../../images/contact/mobile/contact@2x.jpg';

import tabletWebp from '../../images/contact/tablet/contact.webp';
import tabletWebp2x from '../../images/contact/tablet/contact@2x.webp';
import tabletJpeg from '../../images/contact/tablet/contact.jpg';
import tabletJpeg2x from '../../images/contact/tablet/contact@2x.jpg';

import deskWebp from '../../images/contact/desktop/contact.webp';
import deskWebp2x from '../../images/contact/desktop/contact@2x.webp';
import deskJpeg from '../../images/contact/desktop/contact.jpg';
import deskJpeg2x from '../../images/contact/desktop/contact@2x.jpg';

export const images = {
  mobWebp,
  mobWebp2x,
  mobJpeg,
  mobJpeg2x,
  tabletWebp,
  tabletWebp2x,
  tabletJpeg,
  tabletJpeg2x,
  deskWebp,
  deskWebp2x,
  deskJpeg,
  deskJpeg2x,
};
